import { asyncRouterMap, constantRouterMap } from '@/router';
import { employeeModule } from '@/api/home/login';
import { resetRouter } from '@/router';
/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
    // 暂时不启用
    if(route.meta && route.meta.modules) {
        for(const i in roles) {
            if(route.meta.modules.indexOf(roles[i].moduleId) >= 0) {
                if(roles[i].auditCount && roles[i].auditCount != 0) {
                    route.auditCount = roles[i].auditCount;
                }
                return true;
            }
        }
    }else {
        return true;
    }
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param asyncRouterMap
 * @param roles
 */
function filterAsyncRouter(asyncRouterMap, roles) {
    const res = [];
    const noAuth = [];
    const noPaths = [];
    asyncRouterMap.forEach(route => {
        const tmp = { ...route };
        if(hasPermission(roles, tmp)) {
            if(tmp.children) {
                var temp = filterAsyncRouter(tmp.children, roles);
                if(temp.noAuth.length > 0) {
                    const copyTmp = JSON.parse(JSON.stringify(tmp));
                    copyTmp.children = temp.noAuth;
                    noAuth.push(copyTmp);
                    temp.noPaths.forEach(path => {
                        if(path.indexOf('/') != 0) {
                            path = '/' + path;
                        }
                        noPaths.push(tmp.path + path);
                    });
                }
                tmp.children = temp.res;
            }
            res.push(tmp);
        }else {
            if(tmp.children) {
                tmp.children.forEach(item => {
                    var path = item.path;
                    if(path.indexOf('/') != 0) {
                        path = '/' + path;
                    }
                    noPaths.push(tmp.path + path);
                });
            }
            noAuth.push(tmp);
        }
    });
    return {
        res,
        noAuth,
        noPaths
    };
}

// tips: 开发调试路由配置
const devRouteList = [];

const permission = {
    state: {
        routers: constantRouterMap,
        addRouters: [],
        modules: [],
        noAuth: [],
        noPaths: []
    },
    mutations: {
        SET_ROUTERS: (state, routers) => {
            state.addRouters = routers;
            state.routers = constantRouterMap.concat(routers);
        },
        SET_NOAUTH: (state, routers) => {
            state.noAuth = routers;
        },
        SET_NOPATH: (state, routers) => {
            state.noPaths = routers;
        },
        SET_MODULES: (state, modules) => {
            state.modules = modules;
        }
    },
    actions: {
        GenerateRoutes({ commit }, empId) {
            return new Promise((resolve, reject) => {
                employeeModule({ empId }).then(res => {
                    const moduleList = res.data || [];
                    if(process.env.NODE_ENV == "development") {
                        moduleList.push(...devRouteList);
                    }
                    const temObj = filterAsyncRouter(asyncRouterMap, moduleList);
                    if(moduleList.length == 0) {
                        moduleList.push("none");
                    }
                    commit('SET_ROUTERS', temObj.res);
                    commit('SET_NOAUTH', temObj.noAuth);
                    commit('SET_NOPATH', temObj.noPaths);
                    commit('SET_MODULES', moduleList);
                    resolve(temObj.res);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        ClearModules({ commit }) {
            resetRouter();
            commit('SET_MODULES', []);
        }
    }
};

export default permission;
